import { render } from "./cms-contact-persons.vue?vue&type=template&id=20eef272"
import script from "./cms-contact-persons.vue?vue&type=script&lang=js"
export * from "./cms-contact-persons.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__